import { List, ListItem } from "@mui/material";
import { TuristVeg } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import turistvegIconSource from "../../assets/turistveg.svg"

export default function Turistveger(props: IRoutePartProps) {

    return (        
        <>
            {props.roadFeatures && props.roadFeatures.turistVeger && props.roadFeatures.turistVeger.length > 0 &&
            <List>
                {props.roadFeatures.turistVeger.map( (turistveg: TuristVeg, index: number) => (
                    <ListItem 
                    key={turistveg.navn + index} 
                    className="roadFeature" 
                    onClick={(event) => {props.onClick(turistveg, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(turistveg)}
                    onMouseLeave={props.onMouseLeaveItem}>
                        <img src={turistvegIconSource} height="24" style={{paddingRight:"5px"}} alt="Turistveg icon" title="turistvegIcon"/>
                        {turistveg.navn}
                    </ListItem>
                ))}
            </List>        
            }
        </>
    )
}